function flipCategoryTickets(categoryTickets) {
  const stringLength = categoryTickets.length;
  const firstPartCategoryTickets = categoryTickets.substring(
    0,
    stringLength - 2
  );
  let secondPartCategoryTickets = categoryTickets.substring(
    stringLength - 2,
    stringLength
  );

  switch (secondPartCategoryTickets) {
    case "AB":
      secondPartCategoryTickets = "CD";
      break;
    case "CD":
      secondPartCategoryTickets = "AB";
      break;
    default:
      break;
  }
  return firstPartCategoryTickets + secondPartCategoryTickets;
}

export default flipCategoryTickets;
